import React from "react";
import { Drawer, List } from "@mui/material";
import { useSidebarMenus } from "./useSidebarMenus";
import SidebarItem from "./SidebarItem";
import { useIsDesktop } from "../../hooks/useIsDesktop";

/**
 * Sidebar 本体
 */
const Sidebar = ({
  mobileOpen = false,
  onClose,
  onLogout,
  currentUser,
  currentCompanyUser,
  requestNavigate,
  userJobRequestExists,
}) => {
  // 組み立て済みのメニューを取得
  const menus = useSidebarMenus({ currentUser, currentCompanyUser });

  const isDesktop = useIsDesktop();
  /**
   * メニューの key を安定して生成する
   * - static: path を使う
   * - dynamic: key を使う
   * - action: action を使う（logout）
   */
  const getMenuKey = (menu) => {
    if (menu.type === "static") return `static-${menu.path}`;
    if (menu.type === "dynamic") return `dynamic-${menu.key}`;
    if (menu.type === "action") return `action-${menu.action}`;
    return `${menu.type}-${menu.label}`;
  };

  // Drawer 内部の共通コンテンツ
  const content = (
    <List sx={{ p: 0 }}>
      {menus.map((menu) => (
        <SidebarItem
          key={getMenuKey(menu)}
          menu={menu}
          onClose={onClose}
          onLogout={onLogout}
          requestNavigate={requestNavigate}
          userJobRequestExists={userJobRequestExists}
        />
      ))}
    </List>
  );

  // Drawer の見た目（SP/PC 共通のベース）
  const HEADER_HEIGHT = { xs: 50, sm: 63 };
  const paperSx = {
    backgroundColor: "#6C73DD",
    color: "#fff",
    width: 240,
    top: {
      xs: `${HEADER_HEIGHT.xs}px`,
      sm: `${HEADER_HEIGHT.sm}px`,
    },
    height: {
      xs: `calc(100% - ${HEADER_HEIGHT.xs}px)`,
      sm: `calc(100% - ${HEADER_HEIGHT.sm}px)`,
    },
  };

  return (
    <>
      {/* SP: 開閉Drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onClose}
        ModalProps={{
          keepMounted: true,
          disableScrollLock: false, // 背景スクロール禁止
        }}
        slotProps={{
          backdrop: {
            sx: { backgroundColor: "rgba(0,0,0,0.35)" },
          },
        }}
        sx={{
          display: isDesktop ? "none" : "block",
          "& .MuiDrawer-paper": {
            ...paperSx,
            width: { xs: 300, sm: 240 },
            maxWidth: 360,
            backgroundImage: "none",
          },
        }}
      >
        {content}
      </Drawer>

      {/* PC: 常時表示 */}
      <Drawer
        variant="permanent"
        open
        sx={{
          display: isDesktop ? "block" : "none",
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            ...paperSx,
            position: "fixed",
          },
        }}
      >
        {content}
      </Drawer>
    </>
  );
};

export default Sidebar;
